"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _react = _interopRequireDefault(require("react"));

var _I18n = _interopRequireDefault(require("I18n"));

var _formatCurrencyWithCode = _interopRequireDefault(require("../utils/formatCurrencyWithCode"));

var _NumberTypes = _interopRequireDefault(require("../constants/NumberTypes"));

var _NUMBER_FORMATTERS;

var NUMBER_FORMATTERS = (_NUMBER_FORMATTERS = {}, (0, _defineProperty2.default)(_NUMBER_FORMATTERS, _NumberTypes.default.DECIMAL, _I18n.default.formatNumber), (0, _defineProperty2.default)(_NUMBER_FORMATTERS, _NumberTypes.default.CURRENCY, _I18n.default.formatCurrency), (0, _defineProperty2.default)(_NUMBER_FORMATTERS, _NumberTypes.default.PERCENTAGE, _I18n.default.formatPercentage), _NUMBER_FORMATTERS);

var _default = (0, _createReactClass.default)({
  displayName: "FormattedNumber",
  propTypes: {
    abbreviate: _propTypes.default.bool,
    abbreviateThreshold: _propTypes.default.number,
    currencyCode: _propTypes.default.string,
    precision: _propTypes.default.number,
    simplifyCurrency: _propTypes.default.bool,
    stripInsignificantZeros: _propTypes.default.bool,
    style: _propTypes.default.oneOf(Object.keys(_NumberTypes.default).map(function (key) {
      return _NumberTypes.default[key];
    })),
    unit: _propTypes.default.string,
    useCurrencyCode: _propTypes.default.bool,
    value: _propTypes.default.number.isRequired
  },
  getDefaultProps: function getDefaultProps() {
    return {
      simplifyCurrency: false,
      stripInsignificantZeros: true,
      style: _NumberTypes.default.DECIMAL
    };
  },
  render: function render() {
    var _this$props = this.props,
        abbreviate = _this$props.abbreviate,
        abbreviateThreshold = _this$props.abbreviateThreshold,
        value = _this$props.value,
        style = _this$props.style,
        simplifyCurrency = _this$props.simplifyCurrency,
        stripInsignificantZeros = _this$props.stripInsignificantZeros,
        useCurrencyCode = _this$props.useCurrencyCode,
        options = (0, _objectWithoutProperties2.default)(_this$props, ["abbreviate", "abbreviateThreshold", "value", "style", "simplifyCurrency", "stripInsignificantZeros", "useCurrencyCode"]);
    var numberFormatter = NUMBER_FORMATTERS[style];

    if (style === _NumberTypes.default.CURRENCY) {
      console.warn('Using FormattedNumber with the currency style is deprecated. Please use FormattedCurrency instead.');
    }

    if (simplifyCurrency && value % 1 === 0) {
      options.precision = 0;
    }

    if (useCurrencyCode) {
      options.unit = '';
    }

    if (stripInsignificantZeros === false) {
      options.strip_insignificant_zeros = false;
    } else {
      options.strip_insignificant_zeros = true;
    }

    var wrapperAttributes = {};

    if (abbreviate && (typeof abbreviateThreshold !== 'number' || typeof abbreviateThreshold === 'number' && value >= abbreviateThreshold)) {
      wrapperAttributes.title = numberFormatter(value, options);
      options.abbreviate = true;
      options.precision = 0;
    }

    var formattedNumber = numberFormatter(value, options);
    var numberToRender = useCurrencyCode ? (0, _formatCurrencyWithCode.default)(formattedNumber, options.currencyCode) : formattedNumber;
    return _react.default.createElement("span", wrapperAttributes, numberToRender);
  }
});

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/I18n/static-7.547/js/components/FormattedNumber.js
// module id = 401
// module chunks = 209 210 211 212